import { render } from "./VerificationSuccess.vue?vue&type=template&id=6ff8a59c"
import script from "./VerificationSuccess.vue?vue&type=script&lang=js"
export * from "./VerificationSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__